// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueNoty from 'vuejs-noty'
import BootstrapVue, { FormPlugin, OverlayPlugin, LayoutPlugin, ModalPlugin, DropdownPlugin, TablePlugin, ToastPlugin, ButtonPlugin, ButtonGroupPlugin, BootstrapVueIcons } from 'bootstrap-vue'
import VueSidebarMenu from 'vue-sidebar-menu'
import VueCookies from 'vue-cookies'
import Loading from 'vue-loading-overlay'
import VueJwtDecode from 'vue-jwt-decode'
import App from './App'
import router from './router'
import JsonCSV from 'vue-json-csv'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueConfirmDialog from 'vue-confirm-dialog'
import installAnchoredConfirm from './plugins/anchoredConfirm'
import VueMultiselect from 'vue-multiselect'
import Vuelidate from 'vuelidate'
import VueNumeric from 'vue-numeric'

// Fontawesome 5
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import '@/styles/app.scss'
import i18n from './i18n'

// Install BootstrapVue
Vue.use(BootstrapVue)
Vue.use(FormPlugin, OverlayPlugin, ButtonGroupPlugin, ButtonPlugin, ToastPlugin, TablePlugin, DropdownPlugin, ModalPlugin, LayoutPlugin, BootstrapVueIcons)
library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('downloadCsv', JsonCSV)

// Spinner con carga dinámica de color de spinner según licencia
let spinnerColor = '#c26757'
if (window.$cookies && window.$cookies.get('LTI_JWT') !== null && !window.location.href.includes('admin')) {
  const token = window.$cookies.get('LTI_JWT')
  let jwtDecoded = VueJwtDecode.decode(token)
  if (jwtDecoded && jwtDecoded.primaryColor) {
    spinnerColor = jwtDecoded.primaryColor
  }
}

Vue.use(Loading, {
  // Pass props by their camelCased names
  color: spinnerColor,
  loader: 'spinner',
  width: 128,
  height: 128,
  backgroundColor: '#ffffff',
  opacity: 0.5
})

Vue.use(VueNoty, {
  timeout: false,
  progressBar: false,
  layout: 'topCenter',
  modal: true,
  closeWith: ['click', 'button']
})

Vue.use(VueSidebarMenu)
Vue.use(VueCookies)
Vue.use(VueJwtDecode)
Vue.use(VueLodash, { lodash: lodash })
Vue.use(VueConfirmDialog)
Vue.use(VueMultiselect)
Vue.use(Vuelidate)
Vue.use(VueNumeric)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
Vue.component('vue-multiselect', VueMultiselect.default)
// Debe ir después de Vue.use(VueConfirmDialog), que es quien pone $confirm en el
// prototipo: envuelve $confirm para anclar el diálogo al punto del clic en LTI.
installAnchoredConfirm()
const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), {
  moment
})

window.EventBus = new Vue()

Vue.config.productionTip = false

/**
 * Carga de jQuery
 */
window.$ = window.jQuery = require('jquery')

/**
 * Select 2
 */
require('select2')
require('select2/dist/js/i18n/es.js')

window.$.fn.select2.defaults.set('language', 'es')
window.$.fn.select2.defaults.set('theme', 'bootstrap4')
window.$.fn.select2.defaults.set('width', '100%')

/**
 * Biblioteca para el manejo de peticiones al backed. Se construye un acceso global
 * configurado con las opciones por defecto
 */

window.axios = require('axios')

/**
 * Biblioteca para el manejo de fechas
 */

window.moment = moment

/**
 * Se utiliza el título de router como título de las páginas
 */
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '')

    return tag
  }).forEach(tag => document.head.appendChild(tag))

  next()
})

/**
 * Todo acceso a cualuqier ruta de vue, excepto a /login debe ser autenticado
 */
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!window.$cookies || window.$cookies.get('LTI_JWT') == null) {
      next({
        path: '/login'
      })
    } else {
      let token = window.$cookies.get('LTI_JWT')
      let jwtDecoded = VueJwtDecode.decode(token)
      // accesos a /admin** deben tener el rol ADMIN
      // TODO: si actualizamos, cambiar condicion por: jwtDecoded?.roles?.some(role => role == 'ROLE_ADMIN')
      if (to.matched.some((record) => record.path.includes('admin')) && jwtDecoded && jwtDecoded.roles && jwtDecoded.roles.some(role => role === 'ROLE_ADMIN')) {
        next()
      } else {
        return false
      }
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  i18n,
  template: '<App/>'
})

/**
 * EdF: Algoritmo simplificado, se han eliminado heights en CSS
 */
const MIN_HEIGHT = 700
function createResizePostData (height) {
  if (height < MIN_HEIGHT) height = MIN_HEIGHT
  return JSON.stringify({ subject: 'lti.frameResize', height: height })
}

function forceResize (newHeight) {
  parent.postMessage(createResizePostData(newHeight), '*')
}

function changeHeightIFrame () {
  if (window.location.pathname.startsWith('/admin') ||
      window.location.pathname.startsWith('/login')) {
    return
  }

  const finalHeight = Math.max(
    window.$('body').height(),
    window.$('.panel-main-content-height:visible').height() ? window.$('.panel-main-content-height:visible').height() : 0,
    MIN_HEIGHT
  )
  forceResize(finalHeight)
}

window.addEventListener('click', changeHeightIFrame)
window.addEventListener('mouseover', changeHeightIFrame)
window.addEventListener('resize', changeHeightIFrame)



// WEBPACK FOOTER //
// ./src/main.js